var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "1080",
      "persistent": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
            on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_vm.isLoaded ? _c('v-card', {
    attrs: {
      "height": "100%"
    }
  }, [_c('v-card-title', [_vm.isCreate ? [_vm._v("작가 생성")] : [_vm._v("작가 상세")], _c('v-spacer'), _c('v-icon', {
    on: {
      "click": function click($event) {
        _vm.shows = false;
      }
    }
  }, [_vm._v("mdi-close")])], 2), _c('v-divider'), _c('v-card-text', {
    staticClass: "pa-0",
    staticStyle: {
      "max-height": "calc(90vh - 120px)",
      "overflow-y": "auto"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', [_c('v-card-subtitle', [_vm._v("기본 정보")]), _c('v-divider'), _c('v-card-text', [_c('v-row', {
    staticClass: "ma-n2"
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [_c('view-section-field', _vm._b({
    attrs: {
      "label": "썸네일"
    }
  }, 'view-section-field', _vm.attrs_input, false), [_c('v-card', {
    staticClass: "py-3",
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "flat": ""
    }
  }, [_c('image-input', {
    staticClass: "rounded",
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "aspect-ratio": 1 / 1,
      "flat": ""
    },
    model: {
      value: _vm.form.thumb,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "thumb", $$v);
      },
      expression: "form.thumb"
    }
  })], 1)], 1)], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "md": "7"
    }
  }, [_c('v-row', {
    staticClass: "ma-n2"
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "표시순서"
    },
    model: {
      value: _vm.form.index,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "index", $$v);
      },
      expression: "form.index"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('view-section-field', _vm._b({
    attrs: {
      "label": "표시여부"
    }
  }, 'view-section-field', _vm.attrs_input, false), [_c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('v-switch', _vm._b({
    staticClass: "my-2",
    model: {
      value: _vm.form.shows,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "shows", $$v);
      },
      expression: "form.shows"
    }
  }, 'v-switch', _vm.attrs_switch, false))], 1)], 1)], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "국가(국문)"
    },
    model: {
      value: _vm.form.country.ko,
      callback: function callback($$v) {
        _vm.$set(_vm.form.country, "ko", $$v);
      },
      expression: "form.country.ko"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "국가(영문)"
    },
    model: {
      value: _vm.form.country.en,
      callback: function callback($$v) {
        _vm.$set(_vm.form.country, "en", $$v);
      },
      expression: "form.country.en"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "이름(국문)"
    },
    model: {
      value: _vm.form.name.ko,
      callback: function callback($$v) {
        _vm.$set(_vm.form.name, "ko", $$v);
      },
      expression: "form.name.ko"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "이름(영문)"
    },
    model: {
      value: _vm.form.name.en,
      callback: function callback($$v) {
        _vm.$set(_vm.form.name, "en", $$v);
      },
      expression: "form.name.en"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "생년월일",
      "type": "date",
      "clearable": ""
    },
    model: {
      value: _vm.form.bornAt,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "bornAt", $$v);
      },
      expression: "form.bornAt"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "생몰월일",
      "type": "date",
      "clearable": ""
    },
    model: {
      value: _vm.form.diedAt,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "diedAt", $$v);
      },
      expression: "form.diedAt"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', _vm._b({
    attrs: {
      "label": "설명",
      "rows": "7"
    },
    model: {
      value: _vm.form.content,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "content", $$v);
      },
      expression: "form.content"
    }
  }, 'v-textarea', _vm.attrs_input, false))], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "large": "",
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(" 저장하기 ")])], 1)], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }